export const customerConstants = {
    CUSTOMER_FETCHING: 'CUSTOMER_FETCHING',
    CUSTOMER_FETCHED: 'CUSTOMER_FETCHED',
    CUSTOMER_SUBMITTING: 'CUSTOMER_SUBMITTING',
    CUSTOMER_SUBMITTED: 'CUSTOMER_SUBMITTED',
    GET_ALL_CUSTOMERS: 'GET_ALL_CUSTOMERS',
    GET_ACTIVE_CUSTOMERS: 'GET_ACTIVE_CUSTOMERS',
    GET_CUSTOMERS: 'GET_CUSTOMERS',
    GET_CUSTOMER_BY_ID: 'GET_CUSTOMER_BY_ID',

    CLEAR_CUSTOMERS: 'CLEAR_CUSTOMERS',
    GET_SHIPPER_CONSIGNEE: 'GET_SHIPPER_CONSIGNEE',
    CLEAR_GOODS: 'CLEAR_GOODS',

    SEARCH_CUSTOMER: 'SEARCH_CUSTOMER',
    GET_CUSTOMER_PAYOR: 'GET_CUSTOMER_PAYOR',

    SHIPPER_CONSIGNEE_GROUP: 'SHIPPER_CONSIGNEE_GROUP',

    CUSTOMER_RATES_COMMODITY: 'CUSTOMER_RATES_COMMODITY',
    CUSTOMER_PER_BAG: 'CUSTOMER_PER_BAG',
    GET_CUSTOMER_FROM_BASE: 'GET_CUSTOMER_FROM_BASE', 

    GET_STRIPPING_STUFFING: 'GET_STRIPPING_STUFFING',

    GET_COLLECTION_PAYOR: 'GET_COLLECTION_PAYOR',

    GET_CUSTOMER_DETAILS: 'GET_CUSTOMER_DETAILS',

    SHIPPER_COMMODITY: 'SHIPPER_COMMODITY',
    CUSTOMER_RATE_COMMODITY_CATEGORY: 'CUSTOMER_RATE_COMMODITY_CATEGORY',

    COMPUTE_INSURANCE: 'COMPUTE_INSURANCE',

    GET_AE_ID: 'GET_AE_ID',
}